export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/webgeekly-25f60fa27588e21383019e28e98df900.png";